import React from "react";
import { Box } from "@mui/material";
import { appColors } from "../../constants/theme";
import { PAGE_ACTION_BAR_MIN_HEIGHT } from "../../constants/pageActionBar";

const PageActionBar = ({ children, sx = {} }) => (
  <Box
    sx={{
      mb: 3,
      px: { xs: 1.5, md: 2 },
      py: 2,
      minHeight: PAGE_ACTION_BAR_MIN_HEIGHT,
      borderRadius: 2,
      backgroundColor: appColors.white,
      border: `1px solid ${appColors.gray200}`,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 2,
      flexWrap: "wrap",
      ...sx,
    }}
  >
    {children}
  </Box>
);

export default PageActionBar;
